import React from 'react';
import PropTypes from 'prop-types';
import { Chart } from 'react-google-charts';
import { TIME_OUT_RENDER_CHART } from './constants';
import NoData from './NoData';

class TopItemsByCategoryAllChart extends React.Component {
  // need to have differend graph_id for 2 different <Dashboard component (rendered on <Layout/> - sidebar version and non version
  static renderCounter = 0;

  constructor(props) {
    super(props);
    this.state = {
      arrayChart: [],
    };
  }

  componentWillMount() {
    const topItemsByCategory = this._topItemsByCategory(
      this.props.topItemsByCategory
    );
    const idxs = 0;
    this.renderChart(topItemsByCategory, idxs);
  }

  render() {
    return <div>{this.state.arrayChart}</div>;
  }

  _topItemsByCategory = topItemsByCategory => {
    const stateCharts = [];
    Object.entries(topItemsByCategory).map(([key, value]) => {
      const chartRows = [];
      chartRows.push([{ role: 'domain' }, 'Count']);
      value.forEach(val => {
        chartRows.push([val.name, val.count]);
      });
      stateCharts.push({ name: key, rows: chartRows });
    });
    return { charts: stateCharts };
  };

  renderChart = (topItemsByCategory, idxs) => {
    const { ChartLoadingSpinner } = this.props;
    if (topItemsByCategory.charts.length) {
      setTimeout(() => {
        const chartOptions = {
          title: topItemsByCategory.charts[idxs].name,
          legend: { position: 'none' },
          vAxis: { gridlines: { colors: 'transparent' } },
          colors: ['#3498DB', '#3498DB'],
        };
        this.setState({
          arrayChart: this.state.arrayChart.concat(
            <div key={idxs} className="col-md-3">
              <div className="categories-sales-by-volume">
                <Chart
                  chartType="ColumnChart"
                  data={topItemsByCategory.charts[idxs].rows}
                  options={chartOptions}
                  graph_id={
                    `top-items-by-category-${idxs}-chart` +
                    `${TopItemsByCategoryAllChart.renderCounter}`
                  }
                  width="100%"
                  height="200px"
                  legend_toggle
                  loader={<ChartLoadingSpinner />}
                />
              </div>
            </div>
          ),
        });
        idxs++;
        if (idxs < topItemsByCategory.charts.length) {
          this.renderChart(topItemsByCategory, idxs);
        }
      }, TIME_OUT_RENDER_CHART);
    } else {
      this.setState({
        arrayChart: <NoData />,
      });
    }
  };

  componentDidUpdate() {
    TopItemsByCategoryAllChart.renderCounter++;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.topItemsByCategory !== nextProps.topItemsByCategory) {
      TopItemsByCategoryAllChart.renderCounter = 0;
      this.setState({ arrayChart: [] });
      const topItemsByCategory = this._topItemsByCategory(
        nextProps.topItemsByCategory
      );
      const idxs = 0;
      this.renderChart(topItemsByCategory, idxs);
    }
  }
}

TopItemsByCategoryAllChart.propTypes = {
  topItemsByCategory: PropTypes.object,
  ChartLoadingSpinner: PropTypes.func,
};
export default TopItemsByCategoryAllChart;
